const initialState = {
  fetching: false,
};

export default function moderatorReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'FETCHING_MODERATOR':
      return { ...currentState, fetching: true };
    case 'FETCHED_MODERATOR':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
